
import { RoleModel } from "../domain/models/dto/UserDTO";
import { SimpleMapper } from "./SimpleMapper";

export class RoleMapper extends SimpleMapper<RoleModel, RoleModel> {
    protected toDTOFields: string[] = ["id", "name"];
    protected fromDTOFields: string[] = [...this.toDTOFields];
}
